const React = require("react");
const { useInventorySource } = require("../context/InventorySourceContext");
const { useResource } = require("../hooks/useResource");
const { PageHeader, ResourceState } = require("./ui");
const h = React.createElement;

const AdminInventorySourceResource = ({ title, description, loader, collection, columns }) => {
  const { api, t, isAdmin } = useInventorySource();
  const resource = useResource(() => api[loader](), [api, loader]);
  if (!isAdmin) return h("div", { className: "isds-state" }, t("h_inventorySource_admin_only", "Administration access required."));
  const rows = resource.data?.[collection] || [];
  return h(React.Fragment, null,
    h(PageHeader, { title: t(`h_inventorySource_admin_${collection}_title`, title), description: description ? t(`h_inventorySource_admin_${collection}_desc`, description) : "" }),
    h(ResourceState, { loading: resource.loading, error: resource.error, empty: !rows.length, reload: resource.reload, t },
      h("div", { className: "isds-table-wrap" }, h("table", { className: "isds-table" },
        h("thead", null, h("tr", null, ...columns.map((column) => h("th", { key: column.key }, t(`h_inventorySource_admin_col_${column.key}`, column.label))))),
        h("tbody", null, ...rows.map((row) => h("tr", { key: row._id }, ...columns.map((column) => h("td", { key: column.key }, column.render ? column.render(row) : String(row[column.key] ?? "—"))))))
      ))
    )
  );
};

module.exports = { AdminInventorySourceResource };
